import { Vue, Component, Prop } from 'vue-property-decorator';
import { MAudio } from "@/utils/audio";
import moduleStore from '../../store/searchSpeaker';
@Component({
  components: {
  }
})
@moduleStore.initVuex({
  mutationNames:moduleStore.mutationNames,
  actionNames:moduleStore.actionNames
})
export default class SpeakerCards extends Vue{
  self: Vue = this;
  @Prop()speakerResults: Array<any>;
  @Prop()myCloneList: Array<any>;
  @Prop()templateSpeaker: any;//本次模版的发音人speaker字段
  currentClickIndx = null;
  currentClickSpeakerId = null;//当前点击的发音人id
  speakerAudio = null;//发音人视频音频对象
//   heartWhite = require('/public/images/video_editor/heart_white.png');
//   heartRed = require('/public/images/video_editor/heart_red.png');
  playState = "initial";//播放状态
  
  created(){
    this.speakerAudio = MAudio.listen({//试听发音人声音
      playing: () => {
        this.playState = "playing";
      },
      // pause: () => {
      //   this.playState = "paused";
      // },
      ended: () => {
        this.playState = "initial";
      }
    });
  }
  mounted(){
    this.$bus.$on('clearCurrentClickSpeaker',()=>{
        this.clearCurrentClickSpeaker();
    })
  }
  tryListing(speaker){
    if(this.currentClickSpeakerId!=null && this.currentClickSpeakerId === speaker.defaultSpeaker.speakerId &&this.playState === "playing"){
      this.speakerAudio.stop();
      this.playState = "initial";
    }else{ 
      this.currentClickSpeakerId = speaker.defaultSpeaker.speakerId;
      
      let demoUrl = speaker.speakerEmotionCacheVOList[0].demoUrl;
      if(demoUrl){
        this.speakerAudio.setSrc(demoUrl);
        this.speakerAudio.play();
        this.playState = "playing";
      }
    }
    this.$emit('setCurrentSpeaker',speaker);
  }
  selectCurrentSpeaker(speaker,isCloneSpeaker=false){
    if(isCloneSpeaker){//使用我的克隆声音-记录speaker.speaker
        this.currentClickSpeakerId = speaker.speaker;
    }else{
      if(speaker.defaultSpeaker.speakerId !=this.currentClickSpeakerId ){
        this.speakerAudio.stop();
        this.playState = "initial";
        this.currentClickSpeakerId = speaker.defaultSpeaker.speakerId;
      }
    }
    this.$emit('setCurrentSpeaker',speaker)
  }
  cancelListen(){
    this.playState = "initial";
    this.speakerAudio&&this.speakerAudio.stop();
  }

  clearCurrentClickSpeaker(){
    this.currentClickSpeakerId = null;
  }
  //收藏
  clickCollect(speaker){
    this.setFavouritesFn(speaker.builderId);
  }
  setFavouritesFn(builderId){
    let params={
      builderId:builderId,
      voiceType:0
    };
    this.$http('collectSave',params).then(res=>{
      console.log('--收藏返回',res)
      if(res.code===200){
        // let isFavourite = false;//当前是收藏/取消收藏
        //前端页面更新该条数据收藏状态
        let index = this.speakerResults.findIndex(speaker=>speaker.builderId===builderId);
        console.log('--收藏返回',index)
        let targetSpeaker:any = {};
        if(index){
          targetSpeaker = this.speakerResults[index];
          // targetSpeaker.isFavourites = !targetSpeaker.isFavourites;
        }
        this.speakerResults[index].isFavourite = !this.speakerResults[index].isFavourite;
        console.log('--收藏返回',this.speakerResults[index])
        let title = "";
        if (targetSpeaker.isFavourite) {
          title = "收藏成功";
        } else {
          title = "取消收藏";
        }
        this.$toast(`${title}`);
      }
    })
  }
}